import api from '@api/endpoints';
import { setAlert } from '@store/actions/alertActions';

export const getAllVanceCashTxns =
  ({ userId, pageSize = 20, page = 0, onSuccess, onComplete }) =>
  async (dispatch) => {
    try {
      const { data } = await api.vanceCash.getAllTransactions({
        page,
        pageSize,
        userId
      });
      onSuccess && onSuccess(data);
    } catch (error) {
      dispatch(
        setAlert({
          title: error.message,
          status: ALERT_STATUS.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };

export const creditVanceCash =
  ({ userId, amount, remarks, referenceType, onSuccess, onComplete }) =>
  async (dispatch) => {
    try {
      await api.vanceCash.creditVanceCash({
        userId,
        amount,
        remarks,
        referenceType
      });
      onSuccess && onSuccess();
    } catch (error) {
      dispatch(
        setAlert({
          title: error.message,
          status: ALERT_STATUS.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };

export const syncVanceCashWallet =
  ({ userId, onSuccess, onComplete }) =>
  async (dispatch) => {
    try {
      const { data } = await api.vanceCash.syncVanceCashWallet({ userId });
      onSuccess && onSuccess(data);
    } catch (error) {
      dispatch(
        setAlert({
          title: error.message,
          status: ALERT_STATUS.ERROR
        })
      );
    } finally {
      onComplete && onComplete();
    }
  };
